export const buttons = {
    back: "Back",
    next: "Next",
    submit: "Submit Application"
}

export const breadcrumbs = {
    instruct: "Instructions",
    appInfo: "Applicant Information",
    employ: "Employment Information",
    question: "Questionnaire",
    attach: "Attachments",
    addl: "Additional Information",
    sig: "Applicant Affirmation",
    pay: "Payment and Contact Information"
}